import { render, staticRenderFns } from "./JohanVideos.vue?vue&type=template&id=aadd0aea"
import script from "./JohanVideos.vue?vue&type=script&lang=js"
export * from "./JohanVideos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports